(function(){'use strict';
var L=window.PZSE, N=L.CANVAS_PX;
function canvas(){ var c=document.createElement('canvas'); c.width=N; c.height=N; return c; }
function materialOf(cfg){
if(cfg&&(cfg.fx==='none'||cfg.fx==='mesh')) return 'matte';
var sel=L.$all('select[name^="options["]').filter(function(s){return /material/i.test(s.name);})[0];
var v=sel?sel.value:'';
if(!v){ var r=L.$all('input[type=radio][name*="aterial"]:checked')[0]; v=r?r.value:''; }
v=String(v||'').toLowerCase();
if(/holo/.test(v)) return 'holo';
if(/glitter/.test(v)) return 'glitter';
if(/clear/.test(v)) return 'clear';
if(/gloss/.test(v)) return 'gloss';
return 'matte';
}
var noiseC=null, glitterC=null, sparkC=null;
function noise(){
if(noiseC) return noiseC;
var c=document.createElement('canvas'); c.width=c.height=256; var g=c.getContext('2d');
var im=g.createImageData(256,256);
for(var i=0;i<im.data.length;i+=4){ var v=128+(Math.random()-.5)*70; im.data[i]=im.data[i+1]=im.data[i+2]=v; im.data[i+3]=255; }
g.putImageData(im,0,0); return noiseC=c;
}
function glitter(){
if(glitterC) return glitterC;
var c=document.createElement('canvas'); c.width=c.height=320; var g=c.getContext('2d');
g.fillStyle='#cfd1dc'; g.fillRect(0,0,320,320);
for(var i=0;i<3400;i++){
var x=Math.random()*320,y=Math.random()*320,r=Math.random()*1.9+.5,h=Math.random()*360;
g.fillStyle='hsla('+h+',70%,'+(55+Math.random()*40)+'%,'+(.55+Math.random()*.45)+')';
g.beginPath(); g.arc(x,y,r,0,7); g.fill();
}
return glitterC=c;
}
function sparkles(){
if(sparkC) return sparkC;
var c=document.createElement('canvas'); c.width=c.height=320; var g=c.getContext('2d');
for(var i=0;i<90;i++){
var x=Math.random()*320,y=Math.random()*320,r=Math.random()*5+2;
var gr=g.createRadialGradient(x,y,0,x,y,r); gr.addColorStop(0,'rgba(255,255,255,1)'); gr.addColorStop(1,'rgba(255,255,255,0)');
g.fillStyle=gr; g.fillRect(x-r,y-r,r*2,r*2);
g.fillStyle='rgba(255,255,255,.9)'; g.fillRect(x-r*1.4,y-.6,r*2.8,1.2); g.fillRect(x-.6,y-r*1.4,1.2,r*2.8);
}
return sparkC=c;
}
function holoGrad(t, light){
var lx=light?light.x:.5, ly=light?light.y:.5;
var gr=t.createLinearGradient(N*(lx-.9),N*(ly-.9),N*(lx+.9),N*(ly+.9));
var shift=(lx+ly)*180;
for(var i=0;i<=12;i++){ gr.addColorStop(i/12,'hsl('+((i*60+shift)%360)+',95%,'+(i%2?78:66)+'%)'); }
return gr;
}
function masked(body, paint){ var c=canvas(), t=c.getContext('2d'); t.drawImage(body,0,0); t.globalCompositeOperation='source-in'; paint(t); return c; }
function shine(t, light, strength){
var lx=(light?light.x:.3)*N, ly=(light?light.y:.25)*N;
var gr=t.createLinearGradient(lx-N*.5,ly-N*.5,lx+N*.5,ly+N*.5);
gr.addColorStop(0,'rgba(255,255,255,0)'); gr.addColorStop(.34,'rgba(255,255,255,0)');
gr.addColorStop(.44,'rgba(255,255,255,'+(strength*.45)+')'); gr.addColorStop(.5,'rgba(255,255,255,'+strength+')');
gr.addColorStop(.55,'rgba(255,255,255,'+(strength*.25)+')'); gr.addColorStop(.6,'rgba(255,255,255,'+(strength*.5)+')');
gr.addColorStop(.66,'rgba(255,255,255,0)'); gr.addColorStop(1,'rgba(255,255,255,0)');
t.fillStyle=gr; t.fillRect(0,0,N,N);
}
L.fx={
material:materialOf,
labels:{matte:'Matte',gloss:'Glossy',holo:'Holographic',glitter:'Glitter',clear:'Clear'},
base:function(g, body, mat, light){
var c=masked(body,function(t){
if(mat==='holo'){ t.fillStyle=holoGrad(t,light); t.fillRect(0,0,N,N); t.globalCompositeOperation='source-atop'; t.globalAlpha=.18; t.fillStyle=t.createPattern(noise(),'repeat'); t.fillRect(0,0,N,N); }
else if(mat==='glitter'){ t.fillStyle=t.createPattern(glitter(),'repeat'); t.fillRect(0,0,N,N); }
else if(mat==='clear'){ t.fillStyle='rgba(215,228,240,.14)'; t.fillRect(0,0,N,N); }
else { t.fillStyle='#ffffff'; t.fillRect(0,0,N,N); if(mat==='matte'){ t.globalCompositeOperation='source-atop'; t.globalAlpha=.07; t.fillStyle=t.createPattern(noise(),'repeat'); t.fillRect(0,0,N,N); } }
});
g.save(); g.shadowColor=mat==='clear'?'rgba(0,0,0,.10)':'rgba(0,0,0,.28)'; g.shadowBlur=mat==='clear'?8:18; g.shadowOffsetY=mat==='clear'?2:6; g.drawImage(c,0,0); g.restore();
},
finish:function(g, body, mat, light){
if(mat==='matte') return;
if(mat==='holo'){ var h=masked(body,function(t){ t.fillStyle=holoGrad(t,light); t.fillRect(0,0,N,N); }); g.save(); g.globalCompositeOperation='overlay'; g.globalAlpha=.42; g.drawImage(h,0,0); g.restore(); }
if(mat==='glitter'){
var s=masked(body,function(t){ t.fillStyle=t.createPattern(sparkles(),'repeat'); var o=light?light.x*120:0; t.translate(o,o*.6); t.fillRect(-200,-200,N+400,N+400); });
g.save(); g.globalCompositeOperation='screen'; g.globalAlpha=.4; g.drawImage(s,0,0); g.restore();
var gl=masked(body,function(t){ t.fillStyle=t.createPattern(glitter(),'repeat'); t.fillRect(0,0,N,N); });
g.save(); g.globalCompositeOperation='overlay'; g.globalAlpha=.22; g.drawImage(gl,0,0); g.restore();
}
var str=mat==='gloss'?.75:mat==='clear'?.6:mat==='holo'?.45:.3;
var sh=masked(body,function(t){ shine(t,light,str); }); g.drawImage(sh,0,0);
if(mat==='clear'){
var e=canvas(), t=e.getContext('2d');
for(var a=0;a<8;a++){ var an=a*Math.PI/4; t.drawImage(body,Math.cos(an)*1.5,Math.sin(an)*1.5); }
t.globalCompositeOperation='source-in'; t.fillStyle='rgba(120,140,160,.55)'; t.fillRect(0,0,N,N);
t.globalCompositeOperation='destination-out'; t.drawImage(body,0,0); g.drawImage(e,0,0);
}
},
art:function(g,art,x,y,w,h,cfg,light){
if(!cfg||cfg.fx!=='emboss'){ g.drawImage(art,x,y,w,h); return; }
g.save(); g.shadowColor='rgba(0,0,0,.45)'; g.shadowBlur=8; g.shadowOffsetX=2; g.shadowOffsetY=4; g.drawImage(art,x,y,w,h); g.restore();
var c=canvas(), t=c.getContext('2d'); t.drawImage(art,x,y,w,h); t.globalCompositeOperation='source-in';
var lx=(light?light.x:.3)*N, ly=(light?light.y:.25)*N, gr=t.createRadialGradient(lx,ly,10,lx,ly,N*.7); gr.addColorStop(0,'rgba(255,255,255,.38)'); gr.addColorStop(.35,'rgba(255,255,255,.1)'); gr.addColorStop(1,'rgba(255,255,255,0)'); t.fillStyle=gr; t.fillRect(0,0,N,N);
g.drawImage(c,0,0);
var e=canvas(), u=e.getContext('2d'); u.drawImage(art,x-1.5,y-1.5,w,h); u.globalCompositeOperation='source-in'; u.fillStyle='rgba(255,255,255,.4)'; u.fillRect(0,0,N,N); u.globalCompositeOperation='destination-out'; u.drawImage(art,x,y,w,h); g.drawImage(e,0,0);
},
animated:function(mat){ return mat==='holo'||mat==='glitter'||mat==='gloss'||mat==='clear'; },
canvas:canvas
};
})();